import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, OnInit } from '@angular/core';

import i18next from 'i18next';
import { MatButtonModule } from '@angular/material/button';
import { I18NextModule } from 'angular-i18next';
import { NavigationService } from 'src/app/core/services/navigation.service';

import { OrderService } from 'src/app/core/services/order.service';
import { StorageService } from 'src/app/core/storage/storage.service';

import { ListItemComponent } from 'src/app/shared/components/list-item/list-item.component';
import {
  TransfersListResponse,
  JudgementsListResponse,
  RedPlatesListResponse,
  RequestListResponse,
  RequestsResponse,
  ESResponse
} from 'src/app/shared/model/request-list.model';
import { SharedModule } from '../../shared/shared.module';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Translate } from 'src/app/shared/utils/translate';
import { AuthorizationType } from 'src/app/shared/model/authorization.model';
import { EsService } from 'src/app/core/services/es.service';

@Component({
  standalone: true,
  selector: 'app-list-requests',
  templateUrl: './list-requests.component.html',
  styleUrls: ['./list-requests.component.scss'],
  imports: [
    CommonModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    ListItemComponent,
    MatButtonModule,
    MatButtonToggleModule,
    SharedModule
  ]
})
export class ListRequestsComponent implements OnInit, AfterViewInit {
  data = 'active';
  spinner = false;
  listRequest:
    | RequestListResponse[]
    | JudgementsListResponse[]
    | RedPlatesListResponse[]
    | TransfersListResponse[]
    | any = [];
  requestsTypeList = Object.values(AuthorizationType);
  requestList = AuthorizationType;
  requestType = 'requests';
  dataPagination: any;
  pageIndex = 1;
  vehiclesError = '';
  landing2 = false;

  constructor(
    private orderService: OrderService,
    private storageService: StorageService,
    private navigationService: NavigationService,
    public translate: Translate,
    private esService: EsService
  ) {}

  ngOnInit(): void {
    this.pageIndex = this.storageService.get('pageList');
    this.spinner = true;
    this.landing2 = this.storageService.get('landing2') || false;
    this.storageService.set('navigation', 'vehicles');
    this.data = 'active';
    if (this.landing2) this.data = 'inactive';
    this.getRequestsList(this.data === 'active' ? true : false, this.pageIndex);

    this.storageService.set('substitutionVehicle', null);
    this.storageService.set('substitutionVin', null);
    this.storageService.set('substitutionRequestNumber', null);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.navigationService.handleNavigationView('vehicles');
    }, 0);
  }

  changeRequestType(type: string) {
    this.pageIndex = 1;
    this.requestType = type;
    this.data === 'active'
      ? this.getRequestsList(true, this.pageIndex)
      : this.getRequestsList(false, this.pageIndex);
  }

  changeRequestStatus(event: string) {
    this.pageIndex = 1;
    if (event === 'inactive') {
      this.data = 'inactive';
      this.getRequestsList(false, this.pageIndex);
    } else {
      this.data = 'active';
      this.getRequestsList(true, this.pageIndex);
    }
  }

  getRequestsList(active: boolean, page: number) {
    this.spinner = true;
    this.vehiclesError = '';
    this.listRequest = [];
    if (this.requestType === 'requests') {
      this.orderService
        .showOrdersList(
          this.requestType,
          active,
          page,
          undefined,
          this.landing2 ? 'LEASING_ENDOWMENT_LEASING' : undefined
        )
        .subscribe({
          next: (resp: RequestsResponse) => {
            this.spinner = false;
            this.dataPagination = resp;
            this.listRequest = resp.requests;
            if (this.listRequest.length === 0) {
              this.updateVehicleErrorMessage();
            }
          },
          error: () => {
            this.spinner = false;
            this.updateVehicleErrorMessage();
          }
        });
    } else if (this.requestType === AuthorizationType.ES) {
      this.esService.getESList(page).subscribe({
        next: (resp: ESResponse) => {
          this.spinner = false;
          this.dataPagination = resp;
          this.listRequest = resp.entryExits;
          if (this.listRequest.length === 0) {
            this.updateVehicleErrorMessage();
          }
        },
        error: () => {
          this.spinner = false;
          this.updateVehicleErrorMessage();
        }
      });
    } else {
      if (this.requestType === AuthorizationType.RED_PLATES) {
        this.requestType = 'red-plates';
      } else if (this.requestType === AuthorizationType.TRANSFERS) {
        this.requestType = 'transfer';
      }
      this.orderService
        .getRequestList(this.requestType, active, page)
        .subscribe({
          next: (resp: RequestsResponse) => {
            this.spinner = false;
            this.dataPagination = resp;
            this.listRequest = resp.requests;
            if (this.listRequest.length === 0) {
              this.updateVehicleErrorMessage();
            }
          },
          error: () => {
            this.spinner = false;
            this.updateVehicleErrorMessage();
          }
        });
    }
  }

  updateVehicleErrorMessage() {
    switch (this.requestType) {
      case AuthorizationType.REQUESTS:
        this.vehiclesError = i18next.t('noRequests');
        break;
      case 'transfer':
        this.vehiclesError = i18next.t('noTransfers');
        break;
      case 'red-plates':
        this.vehiclesError = i18next.t('noRedPlates');
        break;
      case AuthorizationType.JUDGEMENTS:
        this.vehiclesError = i18next.t('noJudgements');
        break;
      case AuthorizationType.ES:
        this.vehiclesError = i18next.t('noEntryExitData');
        break;
      default:
        this.vehiclesError = i18next.t('noData');
        break;
    }
  }

  updatePage(page: number) {
    this.pageIndex = page + 1;
    this.storageService.set('pageList', this.pageIndex);
    if (this.data === 'active') {
      this.getRequestsList(true, this.pageIndex);
    } else {
      this.getRequestsList(false, this.pageIndex);
    }
  }

  updateList() {
    this.getRequestsList(true, this.pageIndex);
  }
}
